import React from 'react';

import { Box } from '@mui/material';
import TextFieldCDS from '@sharedCR/coreDesignSystem/form/TextFieldCDS';
import AutocompleteCDS from 'app/shared/componentsRestyled/coreDesignSystem/form/AutocompleteCDS/AutocompleteCDS';
import DateFieldCDS from 'app/shared/componentsRestyled/coreDesignSystem/form/DateFieldCDS/DateFieldCDS';
import PropTypes from 'prop-types';

import { COMMON_DATE_FORMAT } from 'constants/date';

import { VendorRequestsTestIds } from '../vendorRequests.testIds';

import { VENDOR_REQUEST_STATUS_OPTIONS } from './VendorRequestsFilters.constants';
import {
  dateFieldStyles,
  filterFieldStyles,
  filtersWrapperStyles,
} from './VendorRequestsFilters.styles';

const VendorRequestsFilters = ({
  requestType,
  vendorName,
  statuses,
  createdAfter = null,
  createdBefore = null,
  onCreatedAfterChange,
  onCreatedBeforeChange,
  onRequestTypeChange,
  onVendorNameChange,
  onStatusesChange,
}) => (
  <Box sx={filtersWrapperStyles}>
    <Box sx={filterFieldStyles}>
      <TextFieldCDS
        dataTestId={VendorRequestsTestIds.REQUEST_TYPE_INPUT}
        label="Request Type"
        name="requestType"
        value={requestType}
        onChange={onRequestTypeChange}
      />
    </Box>
    <Box sx={filterFieldStyles}>
      <TextFieldCDS
        dataTestId={VendorRequestsTestIds.VENDOR_NAME_INPUT}
        label="Vendor"
        name="vendorName"
        value={vendorName}
        onChange={onVendorNameChange}
      />
    </Box>
    <Box sx={filterFieldStyles}>
      <AutocompleteCDS
        multiple
        dataTestId={VendorRequestsTestIds.STATUS_SELECT}
        label="Status"
        name="statuses"
        optionKey="id"
        optionName="name"
        options={VENDOR_REQUEST_STATUS_OPTIONS}
        value={statuses}
        onChange={onStatusesChange}
      />
    </Box>
    <Box sx={dateFieldStyles}>
      <DateFieldCDS
        clearable
        dataTestId={VendorRequestsTestIds.CREATED_AFTER_DATE}
        format={COMMON_DATE_FORMAT}
        label="Created After"
        maxDate={createdBefore}
        value={createdAfter}
        onChange={onCreatedAfterChange}
      />
    </Box>
    <Box sx={dateFieldStyles}>
      <DateFieldCDS
        clearable
        dataTestId={VendorRequestsTestIds.CREATED_BEFORE_DATE}
        format={COMMON_DATE_FORMAT}
        label="Created Before"
        minDate={createdAfter}
        value={createdBefore}
        onChange={onCreatedBeforeChange}
      />
    </Box>
  </Box>
);

VendorRequestsFilters.propTypes = {
  requestType: PropTypes.string.isRequired,
  vendorName: PropTypes.string.isRequired,
  statuses: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      name: PropTypes.string,
    }),
  ).isRequired,
  onCreatedAfterChange: PropTypes.func.isRequired,
  onCreatedBeforeChange: PropTypes.func.isRequired,
  onRequestTypeChange: PropTypes.func.isRequired,
  onVendorNameChange: PropTypes.func.isRequired,
  onStatusesChange: PropTypes.func.isRequired,
  createdAfter: PropTypes.object,
  createdBefore: PropTypes.object,
};

export default VendorRequestsFilters;
